import { useContext, useEffect, useReducer, useState } from "react";
import logo from "./logo-eshopex.png" 
import { AmigoReferid, Redireccion, cuentaCliente } from "../Rutas/Servicios";
import { Get, Post2, PostSinRetorno } from "../Rutas/ApiRest";
import { tokens } from "../Context/Tokens";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { Loading, Modelos } from "./Modelos";
import { Contexto } from "../Context/Contexto";

import { decryptAES, encryptAES } from "../Componentes/encriptacion";
import { CookiesProvider, useCookies } from "react-cookie";

function Solicitud() {
  
  const [state,dispatch]=useReducer(reducer,{nombre:"",apellido:"",email:"",rut:"",telefono:"",ciudad:"",calle:"",numcalle:"",info:""})
  const [TipoCliente,SetTipoCliente]=useState<number>(1)
  const [TipoAmigoReferido,SetTipoAmigoReferido]=useState<number>(0)
  const [cookies, setCookie,removeCookie] = useCookies(['rutcli','mensaje'])
  const [Entrega,SetEntrega]=useState<number>(1)
  const [ValidacionRut,SetValidacionRut]=useState<boolean>(true)
  const [ValidacionTelefono,SetValidacionTelefono]=useState<boolean>(true)
  const [SelectComunaFacturacion,SetSelectComunaFacturacion]=useState<any[]>([])
  const {tok,toggleTodo}=useContext(tokens)
  const {SetLoading,SetMensajeEmergente}=useContext(MensajeContActualizacion)
  const [Terminos,setTermino]=useState<boolean>(false)
  const [Celular,setCelular]=useState<boolean>(false)
  const [ActivoButton,setActivoButton]=useState<boolean>(false)
  const [Ciudad,setCiudad]=useState<number>(0)
  const [Comuna,setComuna]=useState<number>(0)
  const [casillaEspana,SetcasillaEspana]=useState<boolean>(false)
  const {ActualizarCli}=useContext(Contexto)
  const formatotelefono=new RegExp('^((\\+?56\\s)?(0?2|0?3[2-5]|0?4[1-5]|0?5[123578]|0?6[13457]|0?7[1235])?(\\s2\\d{6}|\\s\\d{6}))$')
  const formatoCelular=new RegExp('^(\\+?56)?(\\s?)(0?9)(\\s?)[98765432]\\d{7}$')
  const mensajeCelular="*Celular Invalido (+569 xxxxxxxx)"
  const mensajeTelefono="*Telefono Invalido (+56 (cod area) xxxxxx)"

    useEffect(()=>{
        toggleTodo()
        var datos:any=""
        if(localStorage.getItem('source')==null)
        {
          localStorage.setItem('source',"STD_CL")
          localStorage.setItem("SourceReal","STD_CL")
        }else
        {
          datos=localStorage.getItem('source')
          localStorage.setItem("SourceReal",datos)
        }

        if(localStorage.getItem('email')==null)
        {
            window.location.href=Redireccion.login
        }else
        {
          if(localStorage.getItem('email')!="")
          {
            dispatch({type:"Reinicio"})
          }
        }

        

        if(localStorage.getItem('asillatemporal')!="0")
        { 
          if(localStorage.getItem('asillatemporal')?.includes("CHL"))
          {
            SetTipoAmigoReferido(1)
          }else
          {
            SetTipoAmigoReferido(2)
          }
        }

    },[])

    useEffect(()=>
    {
      validador()
    },[tok])

    const validador=()=>
    {
      if(TipoAmigoReferido>0)
      {
        var datose:any=""
        var identificador:any=""

        if(localStorage.getItem('asillatemporal')!="")
        {
          identificador=localStorage.getItem('asillatemporal')
        }

        if(TipoAmigoReferido==1){
          const datos=Get(AmigoReferid.RevisionReferidor.replace("@ecode",identificador),"application/json",tok)
          datos.then(resultado=>
            {
              if(resultado==1)
              {
                localStorage.setItem("SourceReal","Amigo")
              }else
              {
                datose=localStorage.getItem('source')
                localStorage.setItem("SourceReal",datose)
              }
            })
        }else
        {
          const datos=Get(AmigoReferid.ValidadId.replace("@id",identificador),"application/json",tok)
          datos.then(resultado=>
            {
              if(resultado==1)
              {
                localStorage.setItem("SourceReal","Amigo")
              }else
              {
                datose=localStorage.getItem('source')
                localStorage.setItem("SourceReal",datose)
              }
            })
        }
      }
      
    }



    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":return{nombre:localStorage.getItem('nombre'),apellido:localStorage.getItem('apellido'),email:localStorage.getItem('email'),
        rut:"",telefono:"",ciudad:"",calle:"",numcalle:"",info:""}

        case "ReinicioEmpresa":return{nombre:localStorage.getItem('nombre')+" "+localStorage.getItem('apellido'),email:localStorage.getItem('email'),ciudad:"",calle:"",numcalle:"",info:"",rut:state.rut,telefono:state.telefono}

        case "ReinicioPersona":return{nombre:localStorage.getItem('nombre'),apellido:localStorage.getItem('apellido'),email:localStorage.getItem('email'),ciudad:"",calle:"",numcalle:"",info:"",rut:state.rut,telefono:state.telefono}
      }
    
      return state;
    }

  function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})

      if(event.target.name=="rut")
      {
        verificarRut(event.target.value)
      }
      if(event.target.name=="telefono")
      {
        verificarTelefono(event.target.value)
      }

      
    }

    const verificarRut=(rut:any)=>
    {
      var valor = rut.replace('.','').replace('.','');
    // Despejar Guión
    valor = valor.replace('-','');
    
    // Aislar Cuerpo y Dígito Verificador
    var cuerpo = valor.slice(0,-1);
    var dv = valor.slice(-1).toUpperCase();
    
    // Formatear RUN
    rut = cuerpo + '-'+ dv
    
    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if(cuerpo.length < 7) 
    { 
      SetValidacionRut(false)

    }else
    {
      // Calcular Dígito Verificador
      var suma = 0;
      var multiplo = 2;
      var index=0
      // Para cada dígito del Cuerpo
      for(let i=1;i<=cuerpo.length;i++) {

          // Obtener su Producto con el Múltiplo Correspondiente
          index = multiplo * valor.charAt(cuerpo.length - i);
          
          // Sumar al Contador General
          suma = suma + index;
          
          // Consolidar Múltiplo dentro del rango [2,7]
          if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }

      }

      // Calcular Dígito Verificador en base al Módulo 11
      var dvEsperado = 11 - (suma % 11);

      // Casos Especiales (0 y K)
      dv = (dv == 'K')?10:dv;
      dv = (dv == 0)?11:dv;

      if(dvEsperado!=dv)
      {
        SetValidacionRut(false)
      }else
      {
        SetValidacionRut(true)
      }

    }
    
    

    }
    const RegistroButton=()=>
    {
      if(state.rut=="" || state.telefono=="")
      {
        setActivoButton(false)
      }else
      {
        if(ValidacionRut && ValidacionTelefono)
        {
          setActivoButton(true)
        }else
        {
          setActivoButton(false)
        }
      }
      
    }

    const key=(e:any)=>
    {
      if (e.key === 'Enter')
      {
        carga();
      }
    }
    

    const carga=()=>
    {
      
    }

    const IngresarDatos=()=>
    {
      if(Validador())
      {

        var verificandoRut=state.rut.replace(".","")
        var verificandoRut2=verificandoRut.replace(".","")
        var verificar2=verificandoRut2.split("-")
        const datos=Get(cuentaCliente.ValidacionRegistro.replace("@rut",verificandoRut[0]),"application/json",tok)
        datos.then(resultado=>
          {
            
            if(resultado>1)
            {
              SetMensajeEmergente("Usuario con este rut ya existente")
              SetLoading(false)
            }
            else
            {
              var body={
                "rut":verificar2[0],
                "email":localStorage.getItem('email'),
                "digitoVerificadorRut":verificar2[1]
              }

              const ValidacionRut=Post2(cuentaCliente.ValidacionRut,JSON.stringify(body),"application/json",tok)
              ValidacionRut.then((result:any)=>
                {
                  if(result!="")
                  {
                    SetMensajeEmergente(result)
                    SetLoading(false)
                  }else
                  {
                    var celulares=""
                    var telefonos=""
                    var Ciudades=13
                    var comunas=258
                    if(!Celular)
                    {
                        telefonos=state.telefono
                    }else
                    {
                        celulares=state.telefono
                    }

                    if(Ciudad!=0)
                    {
                      Ciudades=Ciudad
                    }

                    if(Comuna!=0)
                    {
                      comunas=Comuna
                    }


                    var source:any=localStorage.getItem("source")

                    var identificador:any=""
                    

                    if(localStorage.getItem("asillatemporal")!="")
                    {
                      identificador=localStorage.getItem("asillatemporal")
                    }
                    
                    var dato:any=localStorage.getItem("SourceReal")

                    if((verificar2[0]>50000000 || TipoCliente==2) && localStorage.getItem("SourceReal")=="Amigo")
                    {
                      
                      dato=localStorage.getItem('source')
                      localStorage.setItem("SourceReal",dato)
                    }

                    var bodyRegistro=
                    {
                      "rutcli": verificar2[0],
                      "digitoverificador": verificar2[1],
                      "nombre": state.nombre,
                      "apellido": state.apellido,
                      "clave": "98765432",
                      "email": localStorage.getItem("email"),
                      "calle": state.calle,
                      "numero": state.numcalle,
                      "ciudad": state.ciudad,
                      "info": state.info,
                      "comuna": "",
                      "id_comuna": comunas,
                      "region": "",
                      "id_region": Ciudades,
                      "telefono": telefonos,
                      "celular": celulares,
                      "sucursalRetiro": Entrega,
                      "CasillaEspana":casillaEspana,
                      "Source":dato
                    }
                      

                    const datosEcode=Post2(cuentaCliente.RegistroGoogle,JSON.stringify(bodyRegistro),"application/json",tok)
                    datosEcode.then(resultado3=>
                      {
                        var rutcli=resultado3.rutcli

                        if(TipoAmigoReferido>0)
                        {
                          if(TipoAmigoReferido==1)
                          {
                            const id=Get(AmigoReferid.CrearReferidor.replace("@ecode",identificador),"application/json",tok)
                            id.then(resultado=>
                              {
                                const boyAmigo=
                                {
                                  "correo":localStorage.getItem("email"),
                                  "ecode":resultado3.ecode,
                                  "rutcli":resultado3.rutcli,
                                  "id":resultado
                                }

                                const actualizar=PostSinRetorno(AmigoReferid.ActualizarDatos,JSON.stringify(boyAmigo),"application/json",tok)
                                const boyAmigo2=
                                    {
                                      "ecode":resultado3.ecode,
                                      "rutcli":resultado3.rutcli
                                    }
                                    const actualizar4=PostSinRetorno(AmigoReferid.CargandoPuntos,JSON.stringify(boyAmigo2),"application/json",tok)
                                    removeCookie("rutcli")

                                        const dato=Get(cuentaCliente.DatosClientes.replace("@rut",rutcli),"application/json",tok)
                                        dato.then(resultado=>{ActualizarCli(resultado);setCookie('rutcli',encryptAES(rutcli,process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})})
                              })

                          }else
                          {
                            const boyAmigo=
                            {
                              "correo":localStorage.getItem("email"),
                              "ecode":resultado3.ecode,
                              "rutcli":resultado3.rutcli,
                              "id":identificador
                            }

                            const actualizar=PostSinRetorno(AmigoReferid.ActualizarDatos,JSON.stringify(boyAmigo),"application/json",tok)
                            const boyAmigo2=
                                {
                                  "ecode":resultado3.ecode,
                                  "rutcli":resultado3.rutcli
                                }
                                const actualizar4=PostSinRetorno(AmigoReferid.CargandoPuntos,JSON.stringify(boyAmigo2),"application/json",tok)
                                removeCookie("rutcli")

                                    const dato=Get(cuentaCliente.DatosClientes.replace("@rut",rutcli),"application/json",tok)
                                    dato.then(resultado=>{ActualizarCli(resultado);setCookie('rutcli',encryptAES(rutcli,process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})})
                          }


                        }

                      })
                    
                    

                  }
                })
            }
          })
      }
      else
      {
        SetLoading(false)
      }
      SetLoading(false)
    }

    const Validador=()=>
    {
      
      SetLoading(true)
        if(state.nombre=="")
        {
          if(TipoCliente==1)
          {
            SetMensajeEmergente("Debe ingresar nombre")
          }else
          {
            SetMensajeEmergente("Debe ingresar nombre de la empresa")
          }
         
          return false
        }
        if(TipoCliente==1)
        {
          if(state.apellido=="")
          {
            SetMensajeEmergente("Debe ingresar apellido")
            return false
          }
  
        }
        
        
        if(!Terminos)
        {
          SetMensajeEmergente("Debe aceptar los términos y condiciones del contrato")
          return false
        }
        var verificandoRut=state.rut.replace(".","")
        var verificar2=verificandoRut.split("-")

        
        if(verificar2.length!=2)
        {
          SetMensajeEmergente("Debe ingresar su RUT")
          return false
        }
        if(Entrega==0)
        {
          SetMensajeEmergente("Selecione método de entrega")
          return false
        }
        if(Entrega==4)
        {
          if(state.calle=="")
          {
            SetMensajeEmergente("Debe ingresar su dirección")
            return false
          }
          if(state.numcalle=="")
          {
            SetMensajeEmergente("Debe ingresar el número de su dirección")
            return false
          }
          if(state.ciudad=="")
          {
            SetMensajeEmergente("Debe ingresar la ciudad")
            return false
          }
          if(Ciudad==0)
          {
            SetMensajeEmergente("Debe seleccionar su Región de entrega")
            return false
          }
        }

        return true
    }

    const verificarTelefono=(event:any)=>
    {
      
      if(Celular)
      {
        if(formatoCelular.test(event))
        {
          SetValidacionTelefono(true)
        }
        else
        {
          SetValidacionTelefono(false)
        }
      }else
      {
        if(formatotelefono.test(event))
        {
          SetValidacionTelefono(true)
        }
        else
        {
          SetValidacionTelefono(false)
        }
      }

      
    }
    useEffect(()=>
    {
      if(state.telefono!="")
      {
        if(Celular)
        {
          if(formatoCelular.test(state.telefono))
          {
            SetValidacionTelefono(true)
          }
          else
          {
            SetValidacionTelefono(false)
          }
        }else
        {
          if(formatotelefono.test(state.telefono))
          {
            SetValidacionTelefono(true)
          }
          else
          {
            SetValidacionTelefono(false)
          }
        }
      }
      
     
    },[Celular])

    useEffect(()=>
    {
      if(TipoAmigoReferido>0)
      {
        if(TipoCliente==1)
        {
          localStorage.setItem("SourceReal","Amigo")
        }         
      }
    },[TipoCliente])

    useEffect(()=>
    {
      RegistroButton()
    },[ValidacionRut])
    useEffect(()=>
    {
      RegistroButton()
    },[ValidacionTelefono])

    const TraerComuna=(event:any)=>
    {
      setComuna(event.target.value);
    }

    const actualizarComunaPreferente=(id:number)=>
    {
      var cont=0
      const dato2=Get(cuentaCliente.Comunas.replace("@idregion",id+""),"application/json",tok);
        dato2.then(resultado=>{
        resultado.map((e:any)=>{
          if(cont==0)
          {
            setComuna(e.id_comuna)
          }
          SetSelectComunaFacturacion((a:any)=>[...a,<option value={e.id_comuna}>{e.nombre}</option>])
          cont=cont+1
        })
        
      })
    }

    const comuna=(event:any)=>
    {
      SetSelectComunaFacturacion([])
      actualizarComunaPreferente(event.target.value)
      setCiudad(event.target.value)
    }
    const handleChange=()=>
    {
      setTermino(!Terminos)
    }
    const handleEspana=()=>
    {
      SetcasillaEspana(!casillaEspana)
    }

   
    
    return (
      <>
      <CookiesProvider>
      <div className="container">
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
      <div className="container">
      <div className="d-flex justify-content-center py-4" style={{marginTop:"-35px"}}> <a className="logo d-flex align-items-center w-auto img-fluid" href="https://eshopex.cl"> <img src={logo} alt=""></img></a> </div>
      <h5 className="text-center pb-0 fs-4" style={{marginTop:"-20px"}}>Necesita completar estos datos</h5>
        <div className="row justify-content-center">
          
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center">
            
            

            <div className="card mb-3">
              <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Datos Personales</h5>
                </div>
                <div className="row g-3 needs-validation" >
                <div className="col-12">Te registrarás como :
                    <div className="input-group has-validation">

                      <input type="radio" defaultChecked id="Registro" name="Registro" value="1" onClick={()=>{SetTipoCliente(1);dispatch({type:"ReinicioPersona"})}} style={{cursor:"pointer"}}>
                      </input>
                      <strong style={{marginLeft:"5px",marginRight:"10px"}}>Persona</strong>
                      <input type="radio" id="Registro" name="Registro" value="2" onClick={()=>{SetTipoCliente(2);dispatch({type:"ReinicioEmpresa"})}}  style={{cursor:"pointer"}}>
                      </input>
                      <strong style={{marginLeft:"5px"}}>Empresa</strong>
                
                    </div>
                    
                  </div>
                  <div className="col-12">{TipoCliente==1?"Rut":"Rut Empresa"}
                    <div className="input-group has-validation">
                    <input name="rut" type="text" id="rut" className="form-control" value={state.rut} onChange={cambio} onKeyDown={key}></input>
                      
                    </div>
                    {!ValidacionRut?<label style={{color:"red"}}>*Rut Invalido (xx.xxx.xxx-x)</label>:null} 
                  </div>

                  <div className="col-12">{TipoCliente==1?"Nombre":"Nombre Empresa"}
                    <div className="input-group has-validation">
                    <input name="nombre" type="text"  id="nombre" className="form-control" value={state.nombre} onChange={cambio} onKeyDown={key}></input>
                      
                    </div>
                  </div>
                  {TipoCliente==1?<><div className="col-12">Apellido
                    <div className="input-group has-validation">
                    <input name="apellido" type="text"  id="apellido" className="form-control" value={state.apellido} onChange={cambio} onKeyDown={key}></input>
                      
                    </div>
                  </div></>:null}
                  <div className="col-12">Email
                    <div className="input-group has-validation">
                    <input name="email" type="text"  id="email" className="form-control" value={state.email} onKeyDown={key} disabled={true}></input>
                      
                    </div>
                  </div>
                  
                  <div className="col-12">
                    <div className="input-group has-validation">
                    <input type="radio" defaultChecked id="telefono" name="telefono" value="1" onClick={()=>{setCelular(false)}}  style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginLeft:"5px",marginRight:"10px"}}>Telefono</strong>
                <input type="radio" id="Celular" name="telefono" value="2" onClick={()=>{setCelular(true)}}  style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginLeft:"5px"}}>Celular</strong>
                
                    </div>
                    <div className="col-12">
                    <div className="input-group has-validation">
                    
                     <input name="telefono" type="text"  id="telefono" className="form-control" value={state.telefono} onChange={cambio} onKeyDown={key}></input>
                     
                    </div>
                    {!ValidacionTelefono?<label style={{color:"red"}}>{Celular?mensajeCelular:mensajeTelefono}</label>:null}
                  </div>
                  </div>

                  <div className="col-12">
                  <input type="checkbox" id="espana" name="espana" onChange={handleEspana} style={{cursor:"pointer"}}>
                </input> <strong style={{marginRight:"10px"}}>Deseo crear mi Casilla España</strong>
                </div>
                 
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center ">
            
            

            <div className="card mb-3">
              <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Preferencias de entrega</h5>
                </div>
                <div className="row g-3 needs-validation" >
                  <div className="col-12">Selecciona un método de entrega

                  <div className="input-group has-validation">

                      <input type="radio" defaultChecked id="Metodo" name="Metodo" value="1" onClick={()=>{SetEntrega(1)}} style={{cursor:"pointer"}}>
                      </input>
                      <strong style={{marginLeft:"5px",marginRight:"10px"}}>Retiro Sucursal Las Condes</strong>
                      

                      </div>

                      <input type="radio" id="Metodo" name="Metodo" value="2" onClick={()=>{SetEntrega(4)}}  style={{cursor:"pointer"}}>
                      </input>
                      <strong style={{marginLeft:"5px"}}>Despacho Domicilio</strong>
                  </div>
                  
                  
                  {Entrega==4?
                    <>
                    <div className="col-12">Entregar los paquetes en la siguiente dirección:
                    <label style={{marginTop:"10px"}}>Region</label>
                    
                  <select className="col-12 col-m-8" onChange={comuna}>
                      
                      <option value="0">Selecciona</option>
                      <option value="1">Región I</option>
                                                      <option value="2">Región II</option>
                                                      <option value="3">Región III</option>
                                                      <option value="4">Región IV</option>
                                                      <option value="5">Región V</option>
                                                      <option value="6">Región VI</option>
                                                      <option value="7">Región VII</option>
                                                      <option value="8">Región VIII</option>
                                                      <option value="9">Región IX</option>
                                                      <option value="10">Región X</option>
                                                      <option value="11">Región XI</option>
                                                      <option value="12">Región XII</option>
                                                      <option value="13">Región Metropolitana</option>
                                                      <option value="14">Región XIV</option>
                                                      <option value="15">Región XV</option>
                                                      <option value="16">Región XVI</option>
                                                          
                      </select>
                  </div>
                  <div className="col-12">Ciudad
                    <div className="input-group has-validation">
                    <input name="ciudad" type="text"  id="ciudad" className="form-control" value={state.ciudad} onChange={cambio} onKeyDown={key} ></input>
                      
                    </div>
                  </div>
                  {Ciudad>0?<><div className="col-12">Comuna
                  <select className="col-12 col-m-8" onChange={TraerComuna}>
                      
                      {SelectComunaFacturacion}
                                                          
                      </select>
                  </div></>:null}
                  
                  <div className="col-12">Calle
                    <div className="input-group has-validation">
                    <input name="calle" type="text"  id="calle" className="form-control" value={state.calle} onChange={cambio} onKeyDown={key} ></input>
                      
                    </div>
                  </div>
                  <div className="col-12">Número de calle
                    <div className="input-group has-validation">
                    <input name="numcalle" type="text"  id="numcalle" className="form-control" value={state.numcalle} onChange={cambio} onKeyDown={key} ></input>
                      
                    </div>
                  </div>
                  <div className="col-12">Información Complementaria
                    <div className="input-group has-validation">
                    <input name="info" type="text"  id="info" className="form-control" value={state.info} onChange={cambio} onKeyDown={key} ></input>
                      
                    </div>
                  </div>
                  
                    </>:null
                  }
                  
                  <div className="col-12">
                  <input type="checkbox" id="Terminos" name="Terminos" checked={Terminos} onChange={handleChange} style={{cursor:"pointer"}}>
                </input> <strong style={{marginRight:"10px"}}>Acepto los <a href="https://eshopex.cl/terminos-y-condiciones/" target="_blank" rel="noopener noreferrer">Términos y condiciones</a> y la <a href="https://eshopex.cl/politica-de-privacidad/" target="_blank" rel="noopener noreferrer"> Política de privacidad</a> de eShopex.cl</strong>
                </div>
                <div className="col-12">
                  <input type="checkbox" id="Promociones" name="Promociones"  style={{cursor:"pointer"}}>
                </input> <strong style={{marginRight:"10px"}}>Quiero recibir promociones y descuentos especiales</strong>
                </div>
                  
                  <div className="col-12" >
                    <button className="btn btn-primary w-100" type="submit" onClick={()=>{IngresarDatos()}} style={{color:"#fff",backgroundColor:"#f98824",borderColor:"#f98824"}} disabled={!ActivoButton}>¡REGÍSTRATE AHORA!</button>
                  </div>
                  <div className="col-12">
                    <a href={Redireccion.login} onClick={()=>{localStorage.clear()}} style={{textDecoration:"none",color:"#f98824"}}>Volver al Login</a>
                  </div>
                 

                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
  <Modelos></Modelos>
     <Loading></Loading>
     </CookiesProvider>
  </>
  
  
      

      
    );
  }
  
  export default Solicitud;